import { type Breakpoint, type Theme } from '@mui/material';

type Heights = {
  lg?: string;
  md?: string;
  sm?: string;
  xl?: string;
  xs?: string;
};

export const setResponsiveHeight = (theme: Theme, heights: Heights) => {
  const breakpointStyles: Record<string, { paddingBottom: string }> = {};

  for (const [key, value] of Object.entries(heights)) {
    // typescript not inferring key is Breakpoint
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const castKey = key as Breakpoint;

    breakpointStyles[theme.breakpoints.up(castKey)] = {
      paddingBottom: value,
    };
  }

  return breakpointStyles;
};
